// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-8d7a3b":"6a241708beddebcc","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"c06725f2091cc5f7","apps_bom_src_app_offer_offer-wrapper_module_ts":"50e79b066e42bf48"}[chunkId] + ".js";
};